'use client';

import { PortableText } from '@portabletext/react';
import type { TypedObject } from '@portabletext/types';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: TypedObject[];
}

export function BlogFAQ({ faqs }: { faqs: FAQItem[] }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="mx-auto w-[1130px] px-6 py-16 md:w-full md:px-6 md:pt-10">
      <h2 className="mb-8 font-semibold text-[32px] text-black leading-[1.2] sm:text-[24px]">
        Frequently Asked Questions
      </h2>
      <div className="divide-y divide-black/10 border-black/10 border-y">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={item.question}>
              <button
                type="button"
                className="flex w-full cursor-pointer items-center justify-between gap-6 py-6 text-left"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
              >
                <span className="flex-1 font-medium text-black text-lg leading-7 sm:text-base">{item.question}</span>
                <svg
                  className={`size-4 shrink-0 text-black transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <div className="space-y-3 pb-6 text-base text-black/60 leading-6">
                      <PortableText value={item.answer} />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
}
